import { Breadcrumb } from "@chakra-ui/react";
export function BreadcrumbList({ children }) {
  return <Breadcrumb m={[6, 4]}>{children}</Breadcrumb>;
}
